import { storeItems } from "./data"
import { maneuverTypes, maneuverSchools, spellTypes } from "./constants"
export default{
    setStore(type, storeArray){
        //storeArray = JSON.parse(JSON.stringify(storeArray))
        this.setDefault(storeArray)
        switch(type){
            case "basic":
                return this.basicStore(storeArray)
            case "offense":                
                return this.offenseStore(storeArray)
            case "defense":
                return this.defenseStore(storeArray)
            case "items":
                return this.itemStore(storeArray)
            case "training":
                return this.trainingStore(storeArray)
            case "ascension":
                return this.ascensionStore(storeArray)
            case "inn":
                return this.innStore(storeArray)
            case "discount":
                return this.discountStore(storeArray)
            case "magic":
                return this.magicStore(storeArray)

        }
            
    },

    basicStore(storeArray){
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "stats"){
                item.defaultAmount = 6
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true
                    item.list[x].options.rarity.common = false
                    item.list[x].price = item.price + 25
                }
            }
            else if(item.item == "armor"){
                this.setItemsCount(item, 6)
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true
                    item.list[x].options.armor.rarity.common = false
                    item.list[x].options.armorEnchantments.common = false
                    item.list[x].price = item.price + 25
                    item.list[x+2].typed = true
                    item.list[x+2].price = item.price + 25
                }
            }else if(item.item == "weapon"){
                this.setItemsCount(item, 6)
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true
                    item.list[x].options.weapon.rarity.common = false
                    item.list[x].options.weaponEnchantments.rarity.common = false
                    item.list[x].price = item.price + 25
                    item.list[x+2].typed = true
                    item.list[x+2].price = item.price + 25
                }
            }else if(item.item == "enchanted weapon"){
                this.setItemsCount(item, 4)
                item.list[0].specific = true
                item.list[0].options.weapon.rarity.common = false
                item.list[0].options.weaponEnchantments.rarity.common = false                
                item.list[0].price = item.price + 25
                item.list[1].typed = true
                item.list[1].price = item.price + 25                
            }else if(item.item == "enchanted armor"){
                item.defaultAmount = 4
                item.list[0].specific = true
                item.list[0].options.armor.rarity.common = false
                item.list[0].options.armorEnchantments.common = false
                item.list[1].typed = true
                item.list[1].price = item.price + 25                
            }else if(item.item == "Perk"){
                item.defaultAmount = 4
                item.list[0].specific = true
                item.list[0].options.rarity.common = false
                item.list[0].price = item.price + 25
                item.list[1].typed = true
                item.list[1].price = item.price + 25
            }else if(item.item == "Feat"){
                item.defaultAmount = 4
                item.list[0].typed = true
                item.list[0].price = item.price + 25
            }else if(item.item == "wonderousItems"){
                item.defaultAmount = 8
                item.list[0].specific = true
                item.list[1].specific = true
                item.list[0].options.rarity.common = false
                item.list[1].options.rarity.common = false
                item.list[2].typed = true
                item.list[3].typed = true
                item.list[0].price = item.price + 25
                item.list[1].price = item.price + 25
                item.list[2].price = item.price + 25
                item.list[3].price = item.price + 25
            }else if(item.item == "Spell" || item.item == "Maneuver"){
                this.setItemsCount(item, 8)
                if(item.item == "Spell"){
                    for(let x = 0; x < 8; x++){
                        item.list[x].options.type = {damage:true, buff:true, healing:true, utility:true, control:true}
                    }                
                }
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true  
                    item.list[x].price = item.price + 20                    
                }
            }else if(["Rage Power","Rogue Talent", "Ki Power", "Fighter Perk", "Recovery Perk"].includes(item.item)){
                this.setItemsCount(item, 2)
                item.list[0].specific = true
                item.list[0].price = item.price + 25
            }else if(item.item == "Specific Gear"){
                this.setItemsCount(item, 8)
                item.price = [50]                
                for(let x = 0; x < 8; x++){
                    item.list[x].price = 50
                    if(x < 4){
                        item.list[x].options = {type:{ammunition:false, grenade:false, blanch:false, utility:true, implement:false}}
                    }else{
                        item.list[x].options = {type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}}
                    }
                    item.list[x].specific = true
                }
            }else if(item.item == "Item Trade"){
                item.price = 125
                item.defaultAmount = 1
            }else if(item.item == "Finisher"){
                this.setItemsCount(item, 10)
                for(let x = 0; x < 4; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].price = item.price + 20
                }
                for(let x = 4; x < 8; x++){
                    item.list[x].typed = true
                    item.list[x].specific = false
                    item.list[x].price = item.price + 20
                }
            }
        })
        for(let x = 0; x < storeArray.length; x++){
            storeArray.splice(x,1,tempStoreArray[x])
        }
    },

    offenseStore(storeArray){
        this.basicStore(storeArray)
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "armor"){
                this.setItemsCount(item, 4)
                item.list[0].specific = true
                item.list[0].options.armor.rarity.common = false
                item.list[0].options.armorEnchantments.common = false
                item.list[0].price = item.price + 25
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[1].price = item.price + 25
                for(let x = 2; x < 4; x++){
                    item.list[x].specific = false
                    item.list[x].typed = false
                }
                
            }else if(item.item == "weapon"){
                this.setItemsCount(item, 8)
                item.list[0].specific = true
                item.list[0].options.weapon.rarity.common = false
                item.list[0].options.weaponEnchantments.rarity.common = false  
                item.list[0].options.weapon.rarity.rare = false
                item.list[0].options.weaponEnchantments.rarity.rare = false  
                item.list[0].price = item.price + 50
                for(let x = 1; x < 3; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].options.weapon.rarity.common = false
                    item.list[x].options.weaponEnchantments.rarity.common = false
                    item.list[x].price = item.price + 25
                    item.list[x+3].typed = true
                    item.list[x+3].price = item.price + 25
                }
            }else if(item.item == "enchanted weapon"){
                this.setItemsCount(item, 6)
                item.list[0].specific = true
                item.list[0].options.weapon.rarity.common = false
                item.list[0].options.weaponEnchantments.rarity.common = false
                item.list[0].options.weapon.rarity.rare = false
                item.list[0].options.weaponEnchantments.rarity.rare = false
                item.list[0].price = item.price + 50

                item.list[1].specific = true
                item.list[1].typed = false
                item.list[1].options.weapon.rarity.common = false
                item.list[1].options.weaponEnchantments.rarity.common = false                
                item.list[1].price = item.price + 25

                item.list[2].typed = true
                item.list[2].specific = false
                item.list[2].price = item.price + 25
                item.list[3].typed = true
                item.list[3].price = item.price + 25
            }else if(item.item == "enchanted armor"){
                this.setItemsCount(item, 2)
                item.list[0].specific = true
                item.list[0].options.armorEnchantments.common = false
                item.list[0].options.armor.rarity.common = false
                item.list[0].price = 125
                item.list[1].typed = false
                              
            }else if(item.item == "weapon enchantment"){
                item.defaultAmount = 6
            }else if(item.item == "armor enchantment"){
                item.defaultAmount = 2
            }else if(item.item == "Spell"){
                this.setItemsCount(item, 8)                
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true 
                    item.list[x].options.type = {damage:true, buff:false, healing:false, utility:false, control:false}
                    item.list[x].price = item.price
                }
                for(let x = 2; x < 4; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Maneuver"){
                this.setItemsCount(item, 8)
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true 
                    item.list[x].options.type = {Strike:true, Boost:false, Counter:false, Stance:false}
                    item.list[x].price = item.price
                }
                for(let x = 2; x < 4; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Maneuver From School"){
                this.setItemsCount(item, 6)
                item.price = item.price -10
            }else if(item.item == "Rage Power" || item.item == "Fighter Perk"){
                this.setItemsCount(item, 4)
                item.price = item.price - 25
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true
                    item.list[x].price = item.price + 25
                }
            }
            for(let x = 0; x < storeArray.length; x++){
                storeArray.splice(x,1,tempStoreArray[x])
            }
        })
    },

    defenseStore(storeArray){
        this.basicStore(storeArray)
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "weapon"){
                this.setItemsCount(item, 4)
                item.defaultAmount = 4                
                item.list[0].specific = true
                item.list[0].options.weapon.rarity.common = false
                item.list[0].options.weaponEnchantments.common = false
                item.list[0].price = item.price + 25
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[1].price = item.price + 25
                for(let x = 2; x < 4; x++){
                    item.list[x].specific = false
                    item.list[x].typed = false
                }
                
            }else if(item.item == "armor"){
                this.setItemsCount(item, 8)
                item.defaultAmount = 8
                item.list[0].specific = true
                item.list[0].options.armor.rarity.common = false
                item.list[0].options.armorEnchantments.common = false  
                item.list[0].options.armor.rarity.rare = false
                item.list[0].options.armorEnchantments.rare = false  
                item.list[0].price = item.price + 50
                for(let x = 1; x < 3; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].options.armor.rarity.common = false
                    item.list[x].options.armorEnchantments.common = false
                    item.list[x].price = item.price + 25
                    item.list[x+3].typed = true
                    item.list[x+3].price = item.price + 25
                }
            }else if(item.item == "enchanted armor"){
                this.setItemsCount(item, 6)
                item.list[0].specific = true
                item.list[0].options.armor.rarity.common = false
                item.list[0].options.armorEnchantments.common = false
                item.list[0].options.armor.rarity.rare = false
                item.list[0].options.armorEnchantments.rare = false
                item.list[0].price = item.price + 50

                item.list[1].specific = true
                item.list[1].typed = false
                item.list[1].options.armor.rarity.common = false
                item.list[1].options.armorEnchantments.common = false
                item.list[1].price = item.price + 25

                item.list[2].typed = true
                item.list[2].specific = false
                item.list[2].price = item.price + 25
                item.list[3].typed = true
                item.list[3].price = item.price + 25
            }else if(item.item == "enchanted weapon"){     
                           
                this.setItemsCount(item, 2)
                item.list[0].specific = true
                item.list[0].options.weaponEnchantments.common = false
                item.list[0].options.weapon.rarity.common = false
                item.list[0].price = 125
                item.list[1].typed = false
                              
            }else if(item.item == "armor enchantment"){
                item.defaultAmount = 6
            }else if(item.item == "weapon enchantment"){
                item.defaultAmount = 2
            }else if(item.item == "Spell"){
                this.setItemsCount(item, 8)                
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true 
                    item.list[x].options.type = {damage:false, buff:true, healing:true, utility:false, control:false}
                    item.list[x].price = item.price
                }
                for(let x = 2; x < 4; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Maneuver"){
                this.setItemsCount(item, 8)
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true 
                    item.list[x].options.type = {Strike:false, Boost:false, Counter:true, Stance:false}
                    item.list[x].price = item.price
                }
                for(let x = 2; x < 4; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Ki Power" || item.item == "Rogue Talent"){
                this.setItemsCount(item, 4)
                item.price = item.price - 25
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true
                    item.list[x].price = item.price + 25
                }
            }
            for(let x = 0; x < storeArray.length; x++){
                storeArray.splice(x,1,tempStoreArray[x])
            }
        })
    },

    itemStore(storeArray){
        this.basicStore(storeArray)
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "weapon"){
                this.setItemsCount(item, 8)            
                item.list[0].specific = true
                item.list[0].options.weapon.rarity.common = false
                item.list[0].options.weaponEnchantments.common = false
                item.list[0].options.weapon.rarity.rare = false
                item.list[0].options.weaponEnchantments.rare = false
                item.list[0].price = item.price + 50
                for(let x = 1; x < 3; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].options.weapon.rarity.common = false
                    item.list[x].options.weaponEnchantments.common = false
                    item.list[x].price = item.price + 25
                    item.list[x+3].typed = true
                    item.list[x+3].price = item.price + 25
                }                
            }else if(item.item == "armor"){
                this.setItemsCount(item, 8)
                item.defaultAmount = 8
                item.list[0].specific = true
                item.list[0].options.armor.rarity.common = false
                item.list[0].options.armorEnchantments.common = false  
                item.list[0].options.armor.rarity.rare = false
                item.list[0].options.armorEnchantments.rare = false  
                item.list[0].price = item.price + 50
                for(let x = 1; x < 3; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].options.armor.rarity.common = false
                    item.list[x].options.armorEnchantments.common = false
                    item.list[x].price = item.price + 25
                    item.list[x+3].typed = true
                    item.list[x+3].price = item.price + 25
                }
            }else if(item.item == "enchanted armor"){
                this.setItemsCount(item, 6)
                item.list[0].specific = true
                item.list[0].options.armor.rarity.common = false
                item.list[0].options.armorEnchantments.common = false
                item.list[0].options.armor.rarity.rare = false
                item.list[0].options.armorEnchantments.rare = false
                item.list[0].price = item.price + 50

                item.list[1].specific = true
                item.list[1].typed = false
                item.list[1].options.armor.rarity.common = false
                item.list[1].options.armorEnchantments.common = false
                item.list[1].price = item.price + 25

                item.list[2].typed = true
                item.list[2].specific = false
                item.list[2].price = item.price + 25
                item.list[3].typed = true
                item.list[3].price = item.price + 25
            }else if(item.item == "enchanted weapon"){                                
                this.setItemsCount(item, 6)
                item.list[0].specific = true
                item.list[0].options.weapon.rarity.common = false
                item.list[0].options.weaponEnchantments.rarity.common = false
                item.list[0].options.weapon.rarity.rare = false
                item.list[0].options.weaponEnchantments.rarity.rare = false
                item.list[0].price = item.price + 50

                item.list[1].specific = true
                item.list[1].typed = false
                item.list[1].options.weapon.rarity.common = false
                item.list[1].options.weaponEnchantments.rarity.common = false                
                item.list[1].price = item.price + 25

                item.list[2].typed = true
                item.list[2].specific = false
                item.list[2].price = item.price + 25
                item.list[3].typed = true
                item.list[3].price = item.price + 25                              
            }else if(item.item == "armor enchantment"){
                item.defaultAmount = 5
            }else if(item.item == "weapon enchantment"){
                item.defaultAmount = 5
            }else if(item.item == "stats"){
                this.setItemsCount(item, 4)                
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 25
                }
            }else if(item.item == "Spell"){
                this.setItemsCount(item, 4)                
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Maneuver"){
                this.setItemsCount(item, 4)
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Typed Spell"){
                this.setItemsCount(item, 2)
            }else if(item.item == "Maneuver From School" || item.item == "Typed Maneuver"){
                this.setItemsCount(item, 2)
            }else if(item.item == "Finisher"){
                this.setItemsCount(item, 8)
                for(let x = 0; x < 3; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].price = item.price + 25
                }
                for(let x = 3; x < 6; x++){
                    item.list[x].typed = true
                    item.list[x].specific = false
                    item.list[x].price = item.price + 25
                }
            }else if(["Rage Power","Rogue Talent", "Ki Power", "Fighter Perk", "Recovery Perk"].includes(item.item)){
                this.setItemsCount(item, 1)
                item.list[0].specific = false
            }else if(item.item == "Perk"){
                this.setItemsCount(item, 2)
                item.list[1].specific = false
                item.list[1].typed = false
                item.list[1].price = item.price
            }else if(item.item == "Gear"){
                this.setItemsCount(item, 8)
                item.price = 20
            }else if(item.item == "Specific Gear"){
                this.setItemsCount(item, 12)
                item.price = 40
                for(let x = 0; x < 12; x++){
                    item.list[x].specific = true
                    item.list[x].price = 40
                    if(x < 6){
                        item.list[x].options = {type:{ammunition:false, grenade:false, blanch:false, utility:true, implement:false}}
                    }else{
                        item.list[x].options = {type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}}
                    }
                }
            }else if(item.item == "Feat"){
                this.setItemsCount(item, 3)
            }else if(item.item == "Specific Feat"){
                this.setItemsCount(item, 3)
            }
            for(let x = 0; x < storeArray.length; x++){
                storeArray.splice(x,1,tempStoreArray[x])
            }
        })
    },

    trainingStore(storeArray){
        this.basicStore(storeArray)
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "weapon"){
                this.setItemsCount(item, 4)
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
                item.list[3].specific = false
                item.list[3].typed = false
            }else if(item.item == "armor"){
                this.setItemsCount(item, 4)
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
                item.list[3].specific = false
                item.list[3].typed = false
            }else if(item.item == "enchanted armor"){
                this.setItemsCount(item, 3)                
            }else if(item.item == "enchanted weapon"){                                
                this.setItemsCount(item, 3)                              
            }else if(item.item == "armor enchantment"){
                item.defaultAmount = 2
            }else if(item.item == "weapon enchantment"){
                item.defaultAmount = 2
            }else if(item.item == "Spell"){
                this.setItemsCount(item, 12)                
                for(let x = 0; x < 4; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Maneuver"){
                this.setItemsCount(item, 12)
                for(let x = 0; x < 4; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Finisher"){
                this.setItemsCount(item, 12)
                item.price = 50
                for(let x = 0; x < 5; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].price = item.price + 25
                }
                for(let x = 5; x < 10; x++){
                    item.list[x].typed = true
                    item.list[x].specific = false
                    item.list[x].price = item.price + 25
                }
            }else if(item.item == "Typed Spell"){
                this.setItemsCount(item, 6)
            }else if(item.item == "Maneuver From School" || item.item == "Typed Maneuver"){
                this.setItemsCount(item, 6)
            }else if(item.item == "Maneuver Trade Up"){
                this.setItemsCount(item, 10)
                item.price = -20
            }else if(["Rage Power","Rogue Talent", "Ki Power", "Fighter Perk", "Recovery Perk"].includes(item.item)){
                this.setItemsCount(item, 3)
                item.list[1].specific = true
                item.list[1].price += 25
            }else if(item.item == "Perk"){
                this.setItemsCount(item, 6)
                item.list[1].specific = true
                item.list[1].typed = false
                item.list[1].price = item.price + 25
                item.list[2].typed = true
                item.list[2].price = item.price + 25
                item.list[3].typed = true
                item.list[3].price = item.price + 25
            }else if(item.item == "Gear"){
                this.setItemsCount(item, 3)
            }else if(item.item == "Specific Gear"){
                this.setItemsCount(item, 6)
                item.list[3].options = {type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}}
            }else if(item.item == "Feat"){
                this.setItemsCount(item, 6)
                for(let x = 0; x < 3; x++){
                    item.list[x].typed = true
                    item.list[x].price = item.price + 25
                }
            }else if(item.item == "Specific Feat"){
                this.setItemsCount(item, 6)
            }else if(item.item == "Teamwork Feat"){
                this.setItemsCount(item, 4)
            }
            for(let x = 0; x < storeArray.length; x++){
                storeArray.splice(x,1,tempStoreArray[x])
            }
        })
    },

    ascensionStore(storeArray){
        this.basicStore(storeArray)
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "weapon"){
                this.setItemsCount(item, 4)
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
                item.list[3].specific = false
                item.list[3].typed = false
            }else if(item.item == "armor"){
                this.setItemsCount(item, 4)
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
                item.list[3].specific = false
                item.list[3].typed = false
            }else if(item.item == "enchanted armor"){
                this.setItemsCount(item, 3)                
            }else if(item.item == "enchanted weapon"){                                
                this.setItemsCount(item, 3)                              
            }else if(item.item == "armor enchantment"){
                item.defaultAmount = 2
            }else if(item.item == "weapon enchantment"){
                item.defaultAmount = 2
            }else if(item.item == "stats"){
                this.setItemsCount(item, 10)
                item.price = 50                
                for(let x = 0; x < 3; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 25
                }
            }else if(item.item == "Gear"){
                this.setItemsCount(item, 3)
            }else if(item.item == "Specific Gear"){
                this.setItemsCount(item, 4)
                item.list[2].options = {type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}}
                item.list[3].options = {type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}}
            }else if(item.item == "Level Up"){
                this.setItemsCount(item, 6)
                item.price = 250
            }
            for(let x = 0; x < storeArray.length; x++){
                storeArray.splice(x,1,tempStoreArray[x])
            }
        })
    },

    innStore(storeArray){
        this.basicStore(storeArray)
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "weapon"){
                this.setItemsCount(item, 4)
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
                item.list[3].specific = false
                item.list[3].typed = false
            }else if(item.item == "stats"){
                this.setItemsCount(item, 8)                
                for(let x = 0; x < 3; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 25
                }
            }else if(item.item == "armor"){
                this.setItemsCount(item, 4)
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
                item.list[3].specific = false
                item.list[3].typed = false
            }else if(item.item == "enchanted armor"){
                this.setItemsCount(item, 3)                
            }else if(item.item == "enchanted weapon"){                                
                this.setItemsCount(item, 3)                              
            }else if(item.item == "armor enchantment"){
                item.defaultAmount = 3
            }else if(item.item == "weapon enchantment"){
                item.defaultAmount = 3
            }else if(item.item == "Gear"){
                this.setItemsCount(item, 6)
            }else if(item.item == "Specific Gear"){
                this.setItemsCount(item, 12)
                for(let x = 0; x < 12; x++){
                    item.list[x].specific = true
                    if(x < 6){
                        item.list[x].options = {type:{ammunition:false, grenade:false, blanch:false, utility:true, implement:false}}
                    }else{
                        item.list[x].options = {type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}}
                    }
                }
            }else if(item.item == "Feat"){
                this.setItemsCount(item, 3)
                item.list[0].typed = true
                item.list[0].price = item.price + 25    
                item.list[1].typed = false
                item.list[1].price = item.price   
            }else if(item.item == "Specific Feat"){
                this.setItemsCount(item, 3)
            }else if(item.item == "Maneuver From School" || item.item == "Typed Maneuver"){
                this.setItemsCount(item, 2)
            }else if(item.item == "Maneuver Trade Up"){
                this.setItemsCount(item, 4)
            }else if(["Rage Power","Rogue Talent", "Ki Power", "Fighter Perk", "Recovery Perk"].includes(item.item)){
                this.setItemsCount(item, 1)
                item.list[0].specific = false
            }else if(item.item == "Perk"){
                this.setItemsCount(item, 2)
                item.list[1].specific = false
                item.list[1].typed = false
                item.list[1].price = item.price
            }else if(item.item == "Spell"){
                this.setItemsCount(item, 8)                
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true 
                    item.list[x].options.type = {damage:false, buff:false, healing:true, utility:false, control:false}
                    item.list[x].price = item.price
                }
                for(let x = 2; x < 4; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Maneuver"){
                this.setItemsCount(item, 6)
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true 
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Finisher"){
                this.setItemsCount(item, 8)
                for(let x = 0; x < 3; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].price = item.price + 20
                }
                for(let x = 3; x < 6; x++){
                    item.list[x].typed = true
                    item.list[x].specific = false
                    item.list[x].price = item.price + 20
                }
                for(let x = 6; x < 8; x++){
                    item.list[x].typed = false
                    item.list[x].specific = false
                }

            }else if(item.item == "Typed Spell"){
                this.setItemsCount(item, 2)
            }else if(item.potionId && item.defaultAmount > 0){
                item.defaultAmount = item.defaultAmount * 2 
                item.price = Math.ceil(item.price * 0.75)
            }else if(item.item == "Night's Stay"){
                this.setItemsCount(item, 1)
                item.price = 350
            }else if(item.item == "Rent"){
                this.setItemsCount(item, 4)
                item.price = 75
            }else if(item.item == "Maneuver Trade Up"){
                this.setItemsCount(item, 10)
                item.price = 10
            }else if(item.item == "Item Trade"){
                item.price = 75
                item.defaultAmount = 2
            }
            for(let x = 0; x < storeArray.length; x++){
                storeArray.splice(x,1,tempStoreArray[x])
            }
        })
    },

    discountStore(storeArray){
        this.basicStore(storeArray)
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "weapon"){
                item.price = item.price -15
                this.setItemsCount(item, 4)
                item.list[0].price = item.price +25
                item.list[1].price = item.price +25
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
                item.list[3].specific = false
                item.list[3].typed = false
            }else if(item.item == "armor"){
                item.price = item.price -15
                this.setItemsCount(item, 4)
                item.list[0].price = item.price +25
                item.list[1].price = item.price +25
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
                item.list[3].specific = false
                item.list[3].typed = false
            }else if(item.item == "enchanted armor"){
                item.price = item.price -25
                this.setItemsCount(item, 3)
                item.list[0].price = item.price + 25
                item.list[1].price = item.price + 25
            }else if(item.item == "enchanted weapon"){
                item.price = item.price -25                             
                this.setItemsCount(item, 3)
                item.list[0].price = item.price + 25
                item.list[1].price = item.price + 25
            }else if(item.item == "armor enchantment"){
                item.price = item.price -25
                item.defaultAmount = 2
            }else if(item.item == "weapon enchantment"){
                item.price = item.price -25
                item.defaultAmount = 2
            }else if(item.item == "stats"){
                item.price -= 15
                this.setItemsCount(item, 4)
            }else if(item.item == "Gear"){
                this.setItemsCount(item, 3)
                item.price = item.price -10
            }else if(item.item == "Specific Gear"){
                item.price = item.price -15
                this.setItemsCount(item, 6)
                item.list[3].options = {type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}}
            }else if(item.item == "Feat"){
                item.price = item.price -25
                this.setItemsCount(item, 3)
                item.list[0].typed = true
                item.list[0].price = item.price + 25    
                item.list[1].typed = false
                item.list[1].price = item.price   
            }else if(item.item == "Specific Feat"){
                item.price = item.price -25
                this.setItemsCount(item, 3)
            }else if(item.item == "Teamwork Feat"){
                item.price = item.price -50
                this.setItemsCount(item, 1)
            }else if(item.item == "Maneuver From School" || item.item == "Typed Maneuver"){
                this.setItemsCount(item, 3)
                item.price = item.price -15
            }else if(item.item == "Finisher"){
                this.setItemsCount(item, 7)
                item.price = item.price -20
                for(let x = 0; x < 3; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].price = item.price + 20
                }
                for(let x = 3; x < 6; x++){
                    item.list[x].typed = true
                    item.list[x].specific = false
                    item.list[x].price = item.price + 20
                }
                item.list[6].typed = false
                item.list[6].specific = false
            }else if(item.item == "Maneuver Trade Up"){
                this.setItemsCount(item, 4)
                item.price =- 5
            }else if(["Rage Power","Rogue Talent", "Ki Power", "Fighter Perk", "Recovery Perk"].includes(item.item)){
                this.setItemsCount(item, 1)
                item.price = item.price -25
                item.list[0].specific = false
            }else if(item.item == "Perk"){
                item.price = item.price -25
                this.setItemsCount(item, 2)
                item.list[1].specific = false
                item.list[1].typed = false
                item.list[1].price = item.price
            }else if(item.item == "Spell"){
                item.price = item.price -15
                this.setItemsCount(item, 6)
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Maneuver"){
                this.setItemsCount(item, 6)
                item.price = item.price-15
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true 
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Typed Spell"){
                this.setItemsCount(item, 2)
                item.price = item.price -15
            }else if(item.potionId && item.defaultAmount > 0){
                item.defaultAmount = item.defaultAmount -1
                item.price = Math.ceil(item.price * 0.5)
            }else if(item.item == "wonderousItems"){
                item.defaultAmount = 6
                item.price = 80
                item.list[0].specific = true
                item.list[1].typed = true
                item.list[0].price = item.price + 25
                item.list[1].price = item.price + 25
            }
            for(let x = 0; x < storeArray.length; x++){
                storeArray.splice(x,1,tempStoreArray[x])
            }
        })
    },
    magicStore(storeArray){
        this.basicStore(storeArray)
        let tempStoreArray = JSON.parse(JSON.stringify(storeArray))
        tempStoreArray.forEach(item => {
            if(item.item == "weapon"){
                this.setItemsCount(item, 3)
                item.list[0].price = item.price +25
                item.list[1].price = item.price +25
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
            }else if(item.item == "armor"){
                this.setItemsCount(item, 3)
                item.list[0].price = item.price +25
                item.list[1].price = item.price +25
                item.list[1].typed = true
                item.list[1].specific = false
                item.list[2].specific = false
                item.list[2].typed = false
            }else if(item.item == "enchanted armor"){
                this.setItemsCount(item, 6)
                item.list[0].specific = true
                item.list[0].options.armor.rarity.common = false
                item.list[0].options.armorEnchantments.common = false
                item.list[0].options.armor.rarity.rare = false
                item.list[0].options.armorEnchantments.rare = false
                item.list[0].price = item.price + 50

                item.list[1].specific = true
                item.list[1].typed = false
                item.list[1].options.armor.rarity.common = false
                item.list[1].options.armorEnchantments.common = false
                item.list[1].price = item.price + 25

                item.list[2].typed = true
                item.list[2].specific = false
                item.list[2].price = item.price + 25
                item.list[3].typed = true
                item.list[3].price = item.price + 25
            }else if(item.item == "enchanted weapon"){
                this.setItemsCount(item, 6)
                item.list[0].price = item.price + 50
                item.list[1].price = item.price + 25
                item.list[2].price = item.price + 25
                item.list[3].price = item.price + 25
                item.list[0].options.weapon.rarity.rare = false
                item.list[0].options.weaponEnchantments.rarity.rare = false
                item.list[1].options.weapon.rarity.common = false
                item.list[1].options.weaponEnchantments.rarity.common = false
                item.list[1].typed = false
                item.list[1].specific = true
                item.list[2].typed = true
                item.list[3].typed = true
            }else if(item.item == "armor enchantment"){
                item.defaultAmount = 4
            }else if(item.item == "weapon enchantment"){
                item.defaultAmount = 4
            }else if(item.item == "Gear"){
                this.setItemsCount(item, 3)
            }else if(item.item == "Specific Gear"){
                this.setItemsCount(item, 6)
                item.list[3].options = {type:{ammunition:true, grenade:true, blanch:true, utility:true, implement:true}}                
            }else if(item.item == "Feat"){
                this.setItemsCount(item, 3)
                item.list[0].typed = true
                item.list[0].price = item.price + 25    
                item.list[1].typed = false
                item.list[1].price = item.price   
            }else if(item.item == "Specific Feat"){
                this.setItemsCount(item, 3)
            }else if(item.item == "Teamwork Feat"){
                this.setItemsCount(item, 1)
            }else if(item.item == "Maneuver From School" || item.item == "Typed Maneuver"){
                this.setItemsCount(item, 2)
            }else if(item.item == "Maneuver Trade Up"){
                this.setItemsCount(item, 4)
            }else if(item.item == "Finisher"){
                this.setItemsCount(item, 7)
                for(let x = 0; x < 3; x++){
                    item.list[x].specific = true
                    item.list[x].typed = false
                    item.list[x].price = item.price + 20
                }
                for(let x = 3; x < 6; x++){
                    item.list[x].typed = true
                    item.list[x].specific = false
                    item.list[x].price = item.price + 20
                }
                item.list[6].typed = false
                item.list[6].specific = false
            }else if(["Rage Power","Rogue Talent", "Ki Power", "Fighter Perk", "Recovery Perk"].includes(item.item)){
                this.setItemsCount(item, 1)
                item.list[0].specific = false
            }else if(item.item == "Perk"){
                this.setItemsCount(item, 2)
                item.list[1].specific = false
                item.list[1].typed = false
                item.list[1].price = item.price
            }else if(item.item == "Spell"){
                this.setItemsCount(item, 12)
                for(let x = 0; x < 4; x++){
                    item.list[x].specific = true                     
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Maneuver"){
                this.setItemsCount(item, 6)
                for(let x = 0; x < 2; x++){
                    item.list[x].specific = true 
                    item.list[x].price = item.price + 20
                }
            }else if(item.item == "Typed Spell"){
                this.setItemsCount(item, 6)
            }else if(item.item == "wonderousItems"){
                item.defaultAmount = 12
                item.price = 100
                item.list[0].specific = true
                item.list[1].specific = true
                item.list[0].typed = true
                item.list[0].price = item.price + 25
                item.list[0].price = item.price + 25
            }
            for(let x = 0; x < storeArray.length; x++){
                storeArray.splice(x,1,tempStoreArray[x])
            }
        })
    },


    setDefault(storeArray){
        storeArray.forEach(itemType =>{
            let defaultItem = storeItems.find(item => item.item == itemType.item)
            itemType.defaultAmount = defaultItem.defaultAmount
            itemType.price = defaultItem.price
            if(itemType.list){
                itemType.list.forEach(item=>{
                    this.defaultItem(item)
                })
            }
        })
    },

    defaultItem(item){
        item.typed = false
        item.specific = false
        if(item.options){
            if(item.options.rarity){
                Object.keys(item.options.rarity).forEach(rarity => item.options[rarity] = true)
            }
            if(item.options.weapon){
                Object.keys(item.options.weapon.rarity).forEach(rarity=> {item.options.weapon.rarity[rarity] = true})
                Object.keys(item.options.weaponEnchantments.rarity).forEach(rarity=> {item.options.weaponEnchantments.rarity[rarity] = true})
            }
            if(item.options.armor){
                Object.keys(item.options.armor.rarity).forEach(rarity=> {item.options.armor.rarity[rarity] = true})
                Object.keys(item.options.armorEnchantments).forEach(rarity=> {item.options.armorEnchantments[rarity] = true})
            }
            if(item.item == "Spell"){
                item.options.type = spellTypes
            }
            if(item.item == "Maneuver"){
                item.options.type = maneuverTypes
                item.options.school = maneuverSchools
            }        
        }
    },

    setItemsCount(item, targetCount){
        item.defaultAmount = targetCount
        if(item.list){
            let amount = targetCount - item.list.length 
            if(amount > 0){
                for(let x = 0; x < amount; x++){
                    let itemCopy = JSON.parse(JSON.stringify(item.list[0]))
                    this.defaultItem(itemCopy)
                    itemCopy.id = item.list.length
                    item.list.push(itemCopy)
                }
            }else{
                for(let x = 0; x < amount*-1; x++){
                    item.list.splice(-1,1)
                }
            }        
        }
    }
    
}